import ChatApp from './ChatApp'

export default ChatApp
